import { render, staticRenderFns } from "./gerenyushouruxinxi.vue?vue&type=template&id=560aea70&scoped=true"
import script from "./gerenyushouruxinxi.vue?vue&type=script&lang=js"
export * from "./gerenyushouruxinxi.vue?vue&type=script&lang=js"
import style0 from "./gerenyushouruxinxi.vue?vue&type=style&index=0&id=560aea70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560aea70",
  null
  
)

export default component.exports